import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { useShortcuts } from '@atlassian/jira-shortcuts-dialog/src/controllers/shortcuts-service/index.tsx';
import { lazy, LazyWait } from '@atlassian/react-loosely-lazy';
import type { RegisterSearchCriteriaProps } from '../../../common/types.tsx';
import { useIntegrateDotDialogContext } from '../../../controllers/dot-dialog-context/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const RegisterSearchCriteriaToShortcutsDialog = lazy(
	() => import(/* webpackChunkName: "async-register-shortcut-dialog-actions" */ './index'),
);

export const AsyncRegisterSearchCriteriaToShortcutsDialog = (
	props: RegisterSearchCriteriaProps,
) => {
	const [{ isShortcutsDialogVisible }] = useShortcuts();
	const { isShortcutsDialogIntegrationAvailable } = useIntegrateDotDialogContext();

	return (
		<ErrorBoundary
			id="issue-navigatior-search-criteria-shortcuts-dialog"
			packageName="jql-builder-basic"
		>
			<LazyWait until={isShortcutsDialogIntegrationAvailable && isShortcutsDialogVisible}>
				<Placeholder name="async-register-shortcut-dialog-actions" fallback={null}>
					<RegisterSearchCriteriaToShortcutsDialog {...props} />
				</Placeholder>
			</LazyWait>
		</ErrorBoundary>
	);
};
